import { chainId } from './constants/chains'

export const PUBLIC_NODES = {
	[chainId.BINANCE]: ['https://bsc-testnet.publicnode.com'],
	[chainId.ETHEREUM]: ['https://eth-sepolia.public.blastapi.io'],
	[chainId.POLYGON]: ['https://polygon-amoy-bor-rpc.publicnode.com'],
	[chainId.AMOY]: ['https://polygon-amoy-bor-rpc.publicnode.com'],

}
